import logo1 from "../../assets/img/ple/elimination-chamber/logos/2010.png";
import logo2 from "../../assets/img/ple/elimination-chamber/logos/2011.png";
import logo3 from "../../assets/img/ple/elimination-chamber/logos/2012.png";
import logo4 from "../../assets/img/ple/elimination-chamber/logos/2013.png";
import logo5 from "../../assets/img/ple/elimination-chamber/logos/2014.png";
import logo6 from "../../assets/img/ple/elimination-chamber/logos/2015-2017.png";
import logo7 from "../../assets/img/ple/elimination-chamber/logos/2018-2019.png";
import logo8 from "../../assets/img/ple/elimination-chamber/logos/2020.png";
import logo9 from "../../assets/img/ple/elimination-chamber/logos/2021.png";
import logo10 from "../../assets/img/ple/elimination-chamber/logos/2022.png";
import logo11 from "../../assets/img/ple/elimination-chamber/logos/2023.png";
import logo12 from "../../assets/img/ple/elimination-chamber/logos/2024.png";
import logo13 from "../../assets/img/ple/elimination-chamber/logos/2025.png";
import logo14 from "../../assets/img/ple/elimination-chamber/logos/2026.png";

import Winner1 from "../../assets/img/ple/elimination-chamber/winners/ShawnMichaels.png";
import Winner2 from "../../assets/img/ple/elimination-chamber/winners/TripleH.png";
import Winner3 from "../../assets/img/ple/elimination-chamber/winners/TripleH2.png";
import Winner4 from "../../assets/img/ple/elimination-chamber/winners/JohnCena.png";
import Winner5 from "../../assets/img/ple/elimination-chamber/winners/BobbyLashley.png";
import Winner6 from "../../assets/img/ple/elimination-chamber/winners/TripleH3.png";
import Winner7 from "../../assets/img/ple/elimination-chamber/winners/Undertaker.png";
import Winner8 from "../../assets/img/ple/elimination-chamber/winners/Edge.png";
import Winner10 from "../../assets/img/ple/elimination-chamber/winners/ChrisJericho.png";
import Winner11 from "../../assets/img/ple/elimination-chamber/winners/JohnCena2.png";
import Winner13 from "../../assets/img/ple/elimination-chamber/winners/Edge2.png";
import Winner14 from "../../assets/img/ple/elimination-chamber/winners/DanielBryan.png";
import Winner15 from "../../assets/img/ple/elimination-chamber/winners/CMPunk.png";
import Winner16 from "../../assets/img/ple/elimination-chamber/winners/JackSwagger.png";
import Winner17 from "../../assets/img/ple/elimination-chamber/winners/RandyOrton.png";
import Winner18 from "../../assets/img/ple/elimination-chamber/winners/Ryback.png";
import Winner19 from "../../assets/img/ple/elimination-chamber/winners/NewDay.png";
import Winner20 from "../../assets/img/ple/elimination-chamber/winners/BrayWyatt.png";
import Winner21 from "../../assets/img/ple/elimination-chamber/winners/RomanReigns.png";
import Winner22 from "../../assets/img/ple/elimination-chamber/winners/DanielBryan2.png";
import Winner23 from "../../assets/img/ple/elimination-chamber/winners/Miz&Morrison.png";
import Winner24 from "../../assets/img/ple/elimination-chamber/winners/DanielBryan3.png";
import Winner25 from "../../assets/img/ple/elimination-chamber/winners/DrewMcIntyre.png";
import Winner26 from "../../assets/img/ple/elimination-chamber/winners/BrockLesnar.png";
import Winner27 from "../../assets/img/ple/elimination-chamber/winners/AustinTheory.png";
import Winner28 from "../../assets/img/ple/elimination-chamber/winners/DrewMcIntyre2.png";
import Winner29 from "../../assets/img/ple/elimination-chamber/winners/JohnCena3.png";
import Winner30 from "../../assets/img/ple/elimination-chamber/winners/RandyOrton2.png";

export const eliminationChamberDetail = {
  id: "elimination-chamber",
  title: "Elimination Chamber",
  subtitle: "Explore winners and event editions in a dedicated event view.",
  tabs: [
    {
      id: "winners",
      label: "Winners",
      variant: "elimination-chamber",
      items: [
        {
          id: "ec-winner-1",
          title: "Shawn Michaels",
          description: "Survivor Series 2002",
          imgUrl: Winner1,
        },
        {
          id: "ec-winner-2",
          title: "Triple H",
          description: "SummerSlam 2003",
          imgUrl: Winner2,
        },
        {
          id: "ec-winner-3",
          title: "Triple H",
          description: "New Year's Revolution 2005",
          imgUrl: Winner3,
        },
        {
          id: "ec-winner-4",
          title: "John Cena",
          description: "New Year's Revolution 2006",
          imgUrl: Winner4,
        },
        {
          id: "ec-winner-5",
          title: "Bobby Lashley",
          description: "December To Dismember 2006",
          imgUrl: Winner5,
        },
        {
          id: "ec-winner-6",
          title: "Triple H",
          description: "No Way Out 2008 - 2009",
          imgUrl: Winner6,
        },
        {
          id: "ec-winner-7",
          title: "The Undertaker",
          description: "No Way Out 2008",
          imgUrl: Winner7,
        },
        {
          id: "ec-winner-8",
          title: "Edge",
          description: "No Way Out 2009",
          imgUrl: Winner8,
        },
        {
          id: "ec-winner-9",
          title: "Chris Jericho",
          description: "Elimination Chamber 2010",
          imgUrl: Winner10,
        },
        {
          id: "ec-winner-10",
          title: "John Cena",
          description: "Elimination Chamber 2010 - 2011",
          imgUrl: Winner11,
        },
        {
          id: "ec-winner-11",
          title: "Edge",
          description: "Elimination Chamber 2011",
          imgUrl: Winner13,
        },
        {
          id: "ec-winner-12",
          title: "Daniel Bryan",
          description: "Elimination Chamber 2012",
          imgUrl: Winner14,
        },
        {
          id: "ec-winner-13",
          title: "CM Punk",
          description: "Elimination Chamber 2012",
          imgUrl: Winner15,
        },
        {
          id: "ec-winner-14",
          title: "Jack Swagger",
          description: "Elimination Chamber 2013",
          imgUrl: Winner16,
        },
        {
          id: "ec-winner-15",
          title: "Randy Orton",
          description: "Elimination Chamber 2014",
          imgUrl: Winner17,
        },
        {
          id: "ec-winner-16",
          title: "Ryback",
          description: "Elimination Chamber 2015",
          imgUrl: Winner18,
        },
        {
          id: "ec-winner-17",
          title: "The New Day",
          description: "Elimination Chamber 2015",
          imgUrl: Winner19,
        },
        {
          id: "ec-winner-18",
          title: "Bray Wyatt",
          description: "Elimination Chamber 2017",
          imgUrl: Winner20,
        },
        {
          id: "ec-winner-19",
          title: "Roman Reigns",
          description: "Elimination Chamber 2018",
          imgUrl: Winner21,
        },
        {
          id: "ec-winner-20",
          title: "Daniel Bryan",
          description: "Elimination Chamber 2019",
          imgUrl: Winner22,
        },
        {
          id: "ec-winner-21",
          title: "The Miz & John Morrison",
          description: "Elimination Chamber 2020",
          imgUrl: Winner23,
        },
        {
          id: "ec-winner-22",
          title: "Daniel Bryan",
          description: "Elimination Chamber 2021",
          imgUrl: Winner24,
        },
        {
          id: "ec-winner-23",
          title: "Drew McIntyre",
          description: "Elimination Chamber 2021",
          imgUrl: Winner25,
        },
        {
          id: "ec-winner-24",
          title: "Brock Lesnar",
          description: "Elimination Chamber 2022",
          imgUrl: Winner26,
        },
        {
          id: "ec-winner-25",
          title: "Austin Theory",
          description: "Elimination Chamber 2023",
          imgUrl: Winner27,
        },
        {
          id: "ec-winner-26",
          title: "Drew McIntyre",
          description: "Elimination Chamber 2024",
          imgUrl: Winner28,
        },
        {
          id: "ec-winner-27",
          title: "John Cena",
          description: "Elimination Chamber 2025",
          imgUrl: Winner29,
        },
        {
          id: "ec-winner-28",
          title: "Randy Orton",
          description: "Elimination Chamber 2026",
          imgUrl: Winner30,
        },
      ],
    },
    {
      id: "logos",
      label: "Editions",
      variant: "elimination-chamber",
      items: [
        {
          id: "ec-logo",
          title: "Elimination Chamber",
          description: "2010",
          imgUrl: logo1,
        },
        {
          id: "ec-logo-2",
          title: "Elimination Chamber",
          description: "2011",
          imgUrl: logo2,
        },
        {
          id: "ec-logo-3",
          title: "Elimination Chamber",
          description: "2012",
          imgUrl: logo3,
        },
        {
          id: "ec-logo-4",
          title: "Elimination Chamber",
          description: "2013",
          imgUrl: logo4,
        },
        {
          id: "ec-logo-5",
          title: "Elimination Chamber",
          description: "2014",
          imgUrl: logo5,
        },
        {
          id: "ec-logo-6",
          title: "Elimination Chamber",
          description: "2015 - 2017",
          imgUrl: logo6,
        },
        {
          id: "ec-logo-7",
          title: "Elimination Chamber",
          description: "2018 - 2019",
          imgUrl: logo7,
        },
        {
          id: "ec-logo-8",
          title: "Elimination Chamber",
          description: "2020",
          imgUrl: logo8,
        },
        {
          id: "ec-logo-9",
          title: "Elimination Chamber",
          description: "2021",
          imgUrl: logo9,
        },
        {
          id: "ec-logo-10",
          title: "Elimination Chamber",
          description: "2022",
          imgUrl: logo10,
        },
        {
          id: "ec-logo-11",
          title: "Elimination Chamber",
          description: "2023",
          imgUrl: logo11,
        },
        {
          id: "ec-logo-12",
          title: "Elimination Chamber",
          description: "Perth, Australia 2024",
          imgUrl: logo12,
        },
        {
          id: "ec-logo-13",
          title: "Elimination Chamber",
          description: "Toronto, Canadá 2025",
          imgUrl: logo13,
        },
        {
          id: "ec-logo-14",
          title: "Elimination Chamber",
          description: "Chicago 2026",
          imgUrl: logo14,
        },
      ],
    },
  ],
};
